export default __webpack_public_path__ + "static/media/sezgin8.17718dba.jpg";